<div class="row">

	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="card-datatable"
			[options]="false">

			<a
				class="float-right btn btn-sm btn-primary"
				(click)="add()">
				<i
					container="body"
					ngbTooltip="{{'labels.add-building' | translate}}"
					class="feather icon-plus"></i>
			</a>

			<div class="table-responsive">

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="rows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="true"
					[externalSorting]="true"
					[loadingIndicator]="loading"
					[count]="page.totalElements"
					[offset]="page.pageNumber"
					[limit]="page.size"
					(page)="onPageChange($event)"
					(sort)="onSortChange($event)"
					[messages]="{
          emptyMessage: 'labels.empty-buildings' | translate,
          totalMessage: 'labels.total' | translate
		}">
					<!-- ID -->
					<ngx-datatable-column
						[flexGrow]="0.5"
						[name]="'labels.id' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{row.building.id}}
						</ng-template>
					</ngx-datatable-column>

					<!-- NOME -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.name' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<a
								class="link"
								routerLink="/company/building/view/{{row.building.id}}"
								ngbTooltip="{{'labels.building-details' | translate}}">
								{{row.building.name}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<!-- AZIENDA -->
					<ngx-datatable-column
						[flexGrow]="2"
						[name]="'labels.company' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>

							<a
								routerLink="/company/view/{{row.building.company.id}}"
								class="link"
								ngbTooltip="{{'labels.company-details' | translate}}">
								{{row.building.company.name}}
							</a>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">

								<a
									(click)="delete(row)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.delete' | translate}}"
										class="feather icon-trash"></i>
								</a>

							</div>
						</ng-template>
					</ngx-datatable-column>

				</ngx-datatable>
			</div>
		</app-card>
	</div>
</div>
